import React from 'react';
import Services from '../components/Services';

function ServicesPage() {
  return (
    <div style={{ paddingTop: '100px' }}>
      {/* Page Header */}
      <section style={{ padding: '3rem 0', background: 'linear-gradient(135deg, #0A1A2F 0%, #1a3a5f 100%)', color: '#fff' }}>
        <div className="container text-center">
          <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem', fontFamily: 'Montserrat' }}>Our Services</h1>
          <p style={{ fontSize: '1.2rem', color: '#C9A44A' }}>Professional Transportation Solutions Across the UAE</p>
        </div>
      </section>

      <Services />
      
      {/* Additional Services Info */}
      <section style={{ padding: '5rem 0', background: '#0A1A2F', color: '#fff' }}>
        <div className="container text-center">
          <h2 className="section-title-white">Why Choose Our Services?</h2>
          <p style={{ fontSize: '1.1rem', marginTop: '2rem', maxWidth: '800px', margin: '2rem auto', color: '#e0e0e0' }}>
            We provide comprehensive transportation solutions tailored to your specific needs. 
            Whether you need daily staff transport, school buses, or luxury coaches for events, 
            we have the perfect solution for you.
          </p>
          <div style={{ marginTop: '3rem' }}>
            <button className="btn btn-gold" onClick={() => window.location.href = '/contact'} style={{ marginRight: '1rem' }}>
              Request a Quote
            </button>
            <button className="btn btn-outline" onClick={() => window.location.href = '/fleet'}>
              View Our Fleet
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ServicesPage;